import { inventoryItemIdFormat } from "@redotech/redo-ims-id";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getProductInventoryInBin = {
  name: "getProductInventoryInBin" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    storageLocationId: storageLocationIdFormat.schema,
    barcode: z.string(),
    enforceLicensePlateScan: z.boolean().optional(),
    overrideStrictLicensePlateScan: z.boolean().optional(),
  }),
  output: z.object({
    product: z
      .object({
        id: productIdFormat.schema,
        title: z.string(),
        imageUrl: z.string().nullish(),
        sku: z.string().nullish(),
        barcode: z.string().nullish(),
        availableQuantity: z.number(),
        inventoryItemId: inventoryItemIdFormat.schema.nullable(),
        class: z.string().nullable(),
        lotNumber: z.string().nullable(),
        expirationDate: z.string().nullable(),
      })
      .nullable(),
  }),
};
